import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import If from '../../common/if'

const SafeSegment = Segment as unknown as ComponentType<any>

/**
 * Provides a component that renders the encounter reason
 * @param encounter Encounter entity
 * @param mode Render mode. Default: left
 */

type Props = {
  encounter: any
  mode: string | null | undefined
}

function EncounterReason(
  props: Props
): JSX.Element | null {
  const {
    encounter: encounterProp,
    mode: modeProp = 'left'
  } = props
  if (modeProp !== 'left') return null
  return (
    <SafeSegment
      attached
      compact
      className="left-segment"
    >
      <div className="left-title">
        Reason for Visit:
      </div>
      <div className="left-content">
        <If isTrue={ encounterProp.reasonDescription }>
          <span>
            { encounterProp.reasonDescription }
          </span>
        </If>
        <If isTrue={ !encounterProp.reasonDescription }>
          <span className="italic">
            Unavailable
          </span>
        </If>
      </div>
    </SafeSegment>
  )
}

export default EncounterReason
